import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  DECREMENT_QTY,
  REMOVE_ALL_CART,
  WISHLIST_TO_CART,
  CART_UPDATED,
  RECIEVE_GIFTCARD_DETAILS,
  RECEIVE_PROMO,
  UPDATE_TO_SERVER,
  READY_UPDATE_TO_SERVER,
  RECEIVE_SERVER_CART
} from "../constants/ActionTypes";

import toast from "../utils/toast";
import "react-toastify/dist/ReactToastify.min.css";
import { addCartToServer } from "../actions";

const filtersReducerDefaultState = {
  cart: [],
  extended_cart: {
    syncing: false,
    list: []
  },
  gift_card: [{ id: 1, giftCardCode: "abcd", amount: 1000, expiry: "30/09/2022" }],
  promo_details: []
};


export default function cartReducer(
  state = filtersReducerDefaultState,
  action
) {
  switch (action.type) {
    case ADD_TO_CART:
      const variantId = action.variants.id
      if (state.cart.findIndex(product => product.variant.id === variantId) !== -1) {
        const cart = state.cart.reduce((cartAcc, product) => {
          if (product.variant && product.variant.id === variantId) {
            if (action.product.made_to_order === "false") {
              if (product.qty < action.product.stock) {
                toast.success("Item Added to Cart", { toastId: "add-to-cart" });
                cartAcc.push({
                  ...product,
                  qty: product.qty + action.qty,
                  variant: action.variants,
                  sum: action.variants.offerprice * (product.qty + action.qty)
                });

              } else {
                toast.warn("Out of stock", { toastId: "out-of-stock" });
                cartAcc.push({...product});
              }
            } else {
              toast.success("Item Added to Cart", { toastId: "add-to-cart" });
              cartAcc.push({
                ...product,
                qty: product.qty + action.qty,
                variant: action.variants,
                sum: action.variants.offerprice * (product.qty + action.qty)
              });
            }
          } else {
            cartAcc.push(product);
          }
          return cartAcc;
        }, []);
        let new_state = { ...state, cart, extended_cart: { list: [], syncing: true } }
        return new_state;
      }
      toast.success("Item Added to Cart", { toastId: "add-to-cart" });

      return {
        ...state,
        extended_cart: { list: [], syncing: true },
        cart: [
          ...state.cart,
          {
            ...action.product,
            qty: action.qty,
            variant: action.variants,
            sum: action.variants.offerprice * action.qty
          }
        ]
      };

    case READY_UPDATE_TO_SERVER:
      return {
        ...state, extended_cart: { list: [], syncing: true }
      };


    case UPDATE_TO_SERVER:
      return {
        ...state, extended_cart: { list: action.payload.cart, syncing: false }
      };

    case RECEIVE_SERVER_CART:
      return {
        ...state,
        cart: action.payload.cart,
        extended_cart: { list: [], syncing: false }
      };

    case WISHLIST_TO_CART:
      const variant_id = action.variants.id;
      if (state.cart.findIndex(product => product.variant.id === variant_id) !== -1) {
        const cart = state.cart.reduce((cartAcc, product) => {
          if (product.variant.id === variant_id) {
            if (action.product.made_to_order === "false") {
              if (product.qty <= action.product.stock) {
                cartAcc.push({
                  ...product,
                  qty: product.qty + action.qty,
                  variant: action.variants,
                  sum: action.variants.offerprice * (product.qty + action.qty)
                });
              }
            } else {
              cartAcc.push({
                ...product,
                qty: product.qty + action.qty,
                variant: action.variants,
                sum: action.variants.offerprice * (product.qty + action.qty)
              });
            }
          } else {
            cartAcc.push(product);
          }
          return cartAcc;
        }, []);
        return { ...state, cart };
      }
      return {
        ...state,
        cart: [
          ...state.cart,
          {
            ...action.product,
            qty: action.qty,
            variant: action.variants,
            sum: action.variants.offerprice * action.qty
          }
        ]
      };

    case DECREMENT_QTY:
      const variant_Id = action.variant.id
      if (state.cart.findIndex(product => product.variant.id === variant_Id) !== -1) {
        const cart = state.cart.reduce((cartAcc, product) => {
          if (product.variant.id === variant_Id && product.qty > 0) {
            toast.error("Item Removed from Cart", { toastId: "remove-from-cart" });
            cartAcc.push({
              ...product,
              qty: product.qty - 1,
              variant: action.variant,
              sum: product.selectedVariant.offerprice * (product.qty - 1)
            }); // Decrement qty
          } else {
            cartAcc.push(product);
          }
          if (product.variant.id === variant_Id && product.qty === 1) {
            return cartAcc.filter(item => item.variant.id !== action.variant.id);
          }
          return cartAcc;
        }, []);
        return { ...state, cart };
      }
      return {
        ...state,
        cart: [...state.cart,
          {
            ...action.product,
            qty: action.qty,
            sum: action.product.selectedVariant.offerprice * action.qty
          }
        ]
      };
    case REMOVE_FROM_CART:
      return {
        ...state,
        cart: state.cart.filter(item => item.variant.id !== action.variant.id)
      };
    case REMOVE_ALL_CART:
      return {
        ...state,
        cart: []
      };
    case CART_UPDATED:
      state.cart.forEach(oldCartItem => {
        action.payload.forEach(newCartItem => {
          if (oldCartItem.id === newCartItem.id) {
            oldCartItem.variant.offerprice = newCartItem.variant.offerprice
            oldCartItem.selectedVariant.offerprice = newCartItem.variant.offerprice
            oldCartItem.sum = newCartItem.sum
            oldCartItem.active = newCartItem.deleted ? false : true
            // oldCartItem.active = false
          }
        })
      });
      return {
        ...state,
        cart: [...state.cart]
      };
    case RECIEVE_GIFTCARD_DETAILS:
      return {
        ...state,
        gift_card: action.payload
      };
    case RECEIVE_PROMO:
      return {
        ...state,
        promo_details: action.payload
      };
    default:
      return state;
  }
}
